(() => {
  // Temporary editing affects only this document. Nothing is saved or sent.
  if (['127.0.0.1', 'localhost'].includes(location.hostname)) return;
  let active = false;
  const excluded = 'script,style,noscript,textarea,input,select,svg,[contenteditable],[data-browser-text-edit]';
  function enable(root) {
    if (!root || root.nodeType !== 1 || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.textContent.trim() && !node.parentElement.closest(excluded)) nodes.push(node);
    }
    for (const node of nodes) {
      // A neutral inline element avoids customer CSS that styles descendant spans.
      const edit = document.createElement('ys-browser-text');
      edit.dataset.browserTextEdit = '';
      edit.contentEditable = 'plaintext-only';
      edit.spellcheck = true;
      edit.style.cursor = 'text';
      node.replaceWith(edit);
      edit.append(node);
    }
  }
  document.addEventListener('click', event => {
    if (active && event.target.closest('[data-browser-text-edit]')) {
      event.stopImmediatePropagation();
      // Keep the caret click, while disabling enclosing links and controls.
      if (event.target.closest('a,button,label,summary')) event.preventDefault();
      event.target.closest('[data-browser-text-edit]').focus();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 'e') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.repeat) return;
      const rootDocument = window.top.document;
      rootDocument.dispatchEvent(new CustomEvent('yoga-space-browser-edit-mode', { detail: rootDocument.documentElement.dataset.browserEditing !== 'true' }));
      return;
    }
    if (active && event.target.closest('[data-browser-text-edit]')) event.stopPropagation();
  }, true);
  const edited = new Map();
  document.addEventListener('input', event => {
    const edit = event.target.closest('[data-browser-text-edit]');
    if (edit) {
      edited.set(edit.parentElement, edit);
      window.top.document.documentElement.dataset.browserTextChanged = 'true';
    }
  }, true);
  const observer = new MutationObserver(records => {
    observer.disconnect();
    for (const [parent, edit] of edited) {
      if (!parent.isConnected) { edited.delete(parent); continue; }
      if (!parent.contains(edit) && !parent.children.length) parent.replaceChildren(edit);
    }
    for (const record of records) {
      if (record.target.parentElement?.closest('[data-browser-text-edit]')) continue;
      if (record.type === 'characterData') enable(record.target.parentElement);
      else enable(record.target);
    }
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  });
  function setActive(next) {
    if (active === next) return;
    active = next;
    observer.disconnect();
    if (active) {
      enable(document.body);
      observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    } else {
      document.activeElement?.closest('[data-browser-text-edit]')?.blur();
      document.querySelectorAll('[data-browser-text-edit]').forEach(edit => edit.replaceWith(...edit.childNodes));
      edited.clear();
    }
  }
  const rootDocument = window.top.document;
  rootDocument.addEventListener('yoga-space-browser-edit-mode', event => {
    rootDocument.documentElement.dataset.browserEditing = String(event.detail);
    setActive(event.detail);
  });
  setActive(rootDocument.documentElement.dataset.browserEditing === 'true');
})();
